// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4c880b0b","710":"653738f1"}[chunkId] + ".chunk.js";
};